// import { motion } from 'framer-motion'
// import React from 'react'

import { type LinksFunction } from '@remix-run/node';
import * as React from 'react';
import Lightbox from 'yet-another-react-lightbox';
import lightboxCss from 'yet-another-react-lightbox/styles.css';

const IMAGES = [
{
  src: '/img/resized/gallery1.webp',
  alt: 'Gallery 1',
  _id: 1
},
{
  src: '/img/resized/gallery2.webp',
  alt: 'Gallery 2',
  _id: 2
},
{
  src: '/img/resized/gallery3.webp',
  alt: 'Gallery 3',
  _id: 3
},
{
  src: '/img/resized/gallery4.webp',
  alt: 'Gallery 4',
  _id: 4
},
{
  src: '/img/resized/gallery5.webp',
  alt: 'Gallery 5',
  _id: 5
},
{
  src: '/img/resized/gallery6.webp',
  alt: 'Gallery 6',
  _id: 6
}];


const FULL_IMAGES = [
{
  src: '/img/gallery1.png',
  alt: 'Gallery 1',
  _id: 1
},
{
  src: '/img/gallery2.png',
  alt: 'Gallery 2',
  _id: 2
},
{
  src: '/img/gallery3.png',
  alt: 'Gallery 3',
  _id: 3
},
{
  src: '/img/gallery4.png',
  alt: 'Gallery 4',
  _id: 4
},
{
  src: '/img/gallery5.png',
  alt: 'Gallery 5',
  _id: 5
},
{
  src: '/img/gallery6.png',
  alt: 'Gallery 6',
  _id: 6
}];


export const links: LinksFunction = () => {
  return [{ rel: 'stylesheet', href: (lightboxCss as string) }];
};

// export const links: LinksFunction = () => {
// 	return [
// 		{ rel: 'preload', as: 'image', href: '/img/gallery1.png' },
// 		{ rel: 'preload', as: 'image', href: '/img/gallery2.png' },
// 		{ rel: 'preload', as: 'image', href: '/img/gallery3.png' },
// 		{ rel: 'preload', as: 'image', href: '/img/gallery4.png' },
// 		{ rel: 'preload', as: 'image', href: '/img/gallery5.png' },
// 		{ rel: 'preload', as: 'image', href: '/img/gallery6.png' },
// 	]
// }

// export default function GalleryRoute() {
// 	return (
// 		<div className="container flex flex-col py-16 lg:py-0 lg:pb-6">
// 			<h3 className="mb-6 text-6xl">Gallery</h3>

// 			<div className="grid gap-4 sm:grid-cols-2 md:grid-cols-3">
// 				<React.Suspense fallback={null}>
// 					{IMAGES.map(({ src, _id }, index) => (
// 						<div key={_id} className="relative overflow-hidden rounded-sm">
// 							<motion.button
// 								className="aspect-square"
// 								whileTap={{ scale: 1.05 }}
// 							>
// 								<img
// 									src={src}
// 									className="h-full w-full object-cover"
// 									alt={`Gallery ${index + 1}`}
// 									loading="lazy"
// 								/>
// 							</motion.button>
// 						</div>
// 					))}
// 				</React.Suspense>
// 			</div>
// 		</div>
// 	)
// }

export default function GalleryRoute() {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <div className="container flex flex-col py-16 lg:py-0 lg:pb-6">
			<h3 className="mb-6 text-6xl">Gallery</h3>

			<ul className="grid gap-x-4 gap-y-8 sm:grid-cols-2 sm:gap-x-6 lg:grid-cols-3 xl:gap-x-8">
				{IMAGES.map((img) =>
        <li key={img._id} className="relative">
						<div className="group aspect-h-10 aspect-w-7 block w-full overflow-hidden rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 focus-within:ring-offset-gray-100">
							<img
              src={img.src}
              alt=""
              className="pointer-events-none object-cover group-hover:opacity-75" />

							<button
              type="button"
              className="absolute inset-0 focus:outline-none"
              onClick={() => setIsOpen(true)}>

								<span className="sr-only">View details for {img.alt}</span>
							</button>
						</div>
					</li>
        )}
			</ul>

			<Lightbox
        open={isOpen}
        close={() => setIsOpen(false)}
        slides={FULL_IMAGES} />

		</div>);

}